<template>
  <div class="home">
    <home-hero />
    <home-categories />
    <home-top-banner />
    <home-tag :tag="'top'" :tagTitle="'home.tag.top'" />
<!--    <home-feedbacks />-->
    <home-banner-bottom />
    <home-tag :tag="'best'" :tagTitle="'home.tag.best'" />
  </div>
</template>

<script setup>
import HomeHero from "@/components/home/home-hero.vue";
import HomeTag from "@/components/home/home-tag.vue";
import HomeCategories from "@/components/home/home-categories.vue";
import {useRoute} from "vue-router";
import {computed, onMounted} from "vue";
import {Auth} from "@/core/api/auth.js";
import {ElNotification} from "element-plus";
import {useI18n} from "vue-i18n";
import HomeTopBanner from "@/components/home/home-topBanner.vue";
import HomeBannerBottom from "@/components/home/home-bannerBottom.vue";

const route = useRoute()
const {t} = useI18n()

const token = computed(() =>
    route.query.token ? (route.query.token) : undefined,
);
const uid = computed(() =>
    route.query.uid ? (route.query.uid) : undefined,
);
const payment = computed(() =>
    route.query.payment ? (route.query.payment) : undefined,
);
const paymentStatus = computed(() => route.query.success)

const activateAccount = async () => {
  if (token.value && uid.value && route.name === "activate-user") {
    const res = await Auth.activateUser(token.value, uid.value)

    if (res.data.activateUser) {
      ElNotification({
        message: t("popup.activateSuccess"),
        type: "success"
      });
    } else {
      ElNotification({
        message: res.errors[0].message,
        type: "error"
      });
    }
  }
};

onMounted(async () => {
  await activateAccount();

  if (route.name === 'payment') {
    const isSuccess = String(paymentStatus.value).toLowerCase() === 'true';

    if (isSuccess) {
      ElNotification({
        message: t('popup.successPayment'),
        type: "success"
      });
    } else {
      ElNotification({
        message: t('popup.failPayment'),
        type: 'error'
      });
    }
  }
});
</script>

<style lang="scss" scoped>

</style>